'use strict';

angular.module('app')
  .service('cartService', function(Request, GTM, utils, $rootScope, diviacLocalStorage) {

    var Cart = {};

    Cart.shopifyURL = '';
    Cart.productsInCart = [];
    Cart.totalPrice = 0;


    Cart.getProducts = function() {
      var self = this;

      self.productsInCart = window.localStorage['productInCart'] ? JSON.parse(window.localStorage['productInCart']) : [];

      return self.productsInCart;
    };

    Cart.recalculatePrice = function(id) {
      Request.post('booking/products/' + id + '/cart/add/');
    };

    Cart.getTotalPrice = function(products) {
      var items = (window.localStorage['productInCart']) ? JSON.parse(window.localStorage['productInCart']) : [];

      if (products) {
        items = products;
      }

      if (items.length) {
        return _.map(items, function(product) {
          return $rootScope.setValue(product.selectedProduct.priceNet, product.currency, true);
        }).reduce(function(price, n) {
          return price + n;
        });
      }
    };

    Cart.getTotalDue = function(products) {
      var items = (window.localStorage['productInCart']) ? JSON.parse(window.localStorage['productInCart']) : [];

      if (products) {
        items = products;
      }

      if (items.length) {
        return _.map(_.uniq(items, 'vendor'), function(product) {
          return $rootScope.setValue(product.selectedProduct.dueNowAmount, product.currency, true);
        }).reduce(function(price, n) {
          return price + n;
        });
      }
    };

    Cart.createShopifyURL = function() {
      var self = this,
        items = (window.localStorage['productInCart']) ? JSON.parse(window.localStorage['productInCart']) : [];

      self.shopifyURL = utils.shopifyURL;

      _.each(items, function(val) {
        if (val.selectedProduct.externalId) {
          var externalId = val.selectedProduct.externalId.split(':');

          if (val.selectedProduct.dateFrom && val.selectedProduct.dateTo) {
            var qty = utils.dayDiff(val.selectedProduct.dateFrom, val.selectedProduct.dateTo);

            if (val.selectedProduct.qty) {
              qty *= val.selectedProduct.qty;
            }

            self.shopifyURL += externalId[1] + ':' + qty + ',';
          } else {
            var qty = 1;

            if (val.selectedProduct.qty) {
              qty *= val.selectedProduct.qty;
            }

            self.shopifyURL += externalId[1] + ':' + qty + ',';
          }
        }
      });
      return self.shopifyURL;
    };

    Cart.checkout = function() {
      window.location.href = Cart.createShopifyURL();
    };

    Cart.deleteFromCart = function(index, callback) {
      if (window.localStorage['productInCart'] && JSON.parse(window.localStorage['productInCart']).length) {
        var cart = JSON.parse(window.localStorage['productInCart']),
          product = cart[index];

        GTM.products('cart_product_remove', {
          'remove': {
            'products': [{
              title: product.title,
              id: product.id,
              price: product.selectedProduct.pricePerOneProduct,
              brand: product.vendor,
              category: product.selectedProduct.shopKindVerbose,
              quantity: product.selectedProduct.qty
            }]
          }
        });

        cart.splice(index, 1);
        window.localStorage['productInCart'] = JSON.stringify(cart);

        $rootScope.order = false;
      }

      return callback(JSON.parse(window.localStorage['productInCart']), product);
    };

    Cart.cartTotalPrice = function() {
      var self = this;

      if (self.productsInCart.length) {
        self.totalPrice = _.map(self.productsInCart, function(product) {
          return product.selectedProduct.priceNet;
        }).reduce(function(price, n) {
          return price + n;
        });
      }

      return self.totalPrice;
    };

    Cart.getDueNow = function(_this, variants) {
      _this.dueNowLoading = true;

      if (!variants) {
        variants = [];

        _.each(Cart.getProducts(), function(val) {
          var qty = val.selectedProduct.qty;

          if (val.kind == 20) {
            qty = qty * utils.dayDiff(val.selectedProduct.dateFrom, val.selectedProduct.dateTo);
          }

          variants.push({
            variant: val.selectedProduct.id,
            quantity: qty
          });
        });
      }

      return Request.post('booking/checkout/due-now/', {
        variants: variants
      }).then(function(res) {
        var amountDue = {
          percent: 0,
          shopQty: res.data.dueNow.length,
          amount: 0
        };

        _.each(res.data.dueNow, function(val) {
          amountDue.amount += $rootScope.setValue(val.dueNowAmount, val.shopCurrency, true, "USD");
          amountDue.percent = +val.dueNowPercents;
        });

        diviacLocalStorage.set('dueNow', amountDue);
        _this.dueNowLoading = false;
        _this.dueNow = amountDue;

        return res.data;

      }).catch(function() {
        _this.dueNowLoading = false;
      });
    };

    Cart.getDueNowValue = function() {
      return window.localStorage['dueNow'] ? JSON.parse(window.localStorage['dueNow']) : null;
    };

    Cart.onlyDiveProducts = function() {
      var onlyDP = _.filter(Cart.getProducts(), function(val) {
        return val.kind != 30 && val.kind != 40 && val.kind != 50;
      });

      return !onlyDP.length;
    };

    return Cart;

  });